(function () {
  "use strict";

  // CADASTRAR FOTOS
  if ($("#dzupload-fotos").length > 0) {
    Dropzone.autoDiscover = false;

    var dzupload = $("#dzupload-fotos");
    var form = $("#form-fotos");
    var btn = $("#cadastrar-fotos");
    var urlForm = form.attr("action");
    var maxFile = dzupload.data("maxfile");
    var maxSize = dzupload.data("maxsize");
    var required = dzupload.data("required") == "sim" ? true : false;

    dzupload.dropzone({
      url: urlForm,
      uploadMultiple: true,
      autoProcessQueue: false,
      parallelUploads: 100,
      paramName: "fotos",
      maxFilesize: maxSize,
      maxFiles: maxFile,
      acceptedFiles: "image/jpg,image/jpeg,image/png,image/gif",
      addRemoveLinks: true,
      dictDefaultMessage: "Clique ou arraste para carregar as fotos",
      dictRemoveFile: "Remover",
      dictFileTooBig:
        "O tamanho do arquivo selecionado é maior do que o limite de <b>" +
        maxSize +
        "Mb</b>",
      dictInvalidFileType: "Tipo de arquivo inválido",
      dictMaxFilesExceeded: "Selecione no máximo <b>" + maxFile + "</b> fotos",
      dictResponseError: "server_error",

      init: function () {
        var myDropzone = this;

        // Evento ao clicar no botão de cadastrar
        btn.on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Valida o formulário
          if (form.parsley().validate()) {
            // Verifica se alguma imagem foi selecionada
            if (myDropzone.files.length > 0) {
              // Envia o formulário
              myDropzone.processQueue();
            } else {
              $(".dz-msg-error").html(
                "É necessário cadastrar pelo menos uma foto."
              );
              scrollToX(".dz-msg-error");
            }
          }
        });

        // Envio sendo processado
        myDropzone.on("sendingmultiple", function (file, xhr, formData) {
          // Resgata os dados do formulário
          var data = form.serializeArray();
          for (var i = 0; i < data.length; i++) {
            formData.append(data[i].name, data[i].value);
          }
          showLoading();
        });

        // Sucesso
        myDropzone.on("successmultiple", function (files, response) {
          console.log(response);
          if (response == "ok") {
            const acaoFotos = $("#acao-fotos").val();
            const retorno = $("#retorno-fotos").val();
            if (acaoFotos == "update") {
              hideLoading();
              showAlert("Sucesso", "Fotos cadastradas com sucesso.", "success");
              setTimeout(() => {
                location.reload();
              }, 2000);
            } else {
              window.location.href = retorno;
            }
          } else {
            hideLoading();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        });

        // Erro
        myDropzone.on("error", function (file, response) {
          console.log(response);
          myDropzone.removeFile(file);
          $(".dz-msg-error").html(response);
          scrollToX(".dz-msg-error");
          hideLoading();

          if (response == "server_error") {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        });

        myDropzone.on("addedfile", function () {
          $(".dz-msg-error").html("");
        });
      },
    });
  }

  // REMOVE FOTO
  var enviando_formulario = false;
  $("#form-remove-foto").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          data = JSON.parse(data);
          if (data.status == "ok") {
            $("#id_remove").val("");
            showAlert("Sucesso", "Foto removida com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // Exibe o modal para descricao da foto
  $(".btn-descricao").on("click", function (e) {
    e.preventDefault();
    var idDescricao = $(this).data("id");
    $("#id_destaque_2").val(idDescricao);
    $("#descricao-foto").val($(this).data("descricao"));
    openModal("modal-confirm3");
  });

  // Exibe a confirmação ao clicar no botão tornar foto destaque
  $(".btn-dest").on("click", function (e) {
    e.preventDefault();
    var idDestaque = $(this).data("id");
    $("#id_destaque").val(idDestaque);
    openModal("modal-confirm2");
  });

  // UPDATE FOTO
  enviando_formulario = false;
  $("#form-update-foto").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm2");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          data = JSON.parse(data);
          if (data.status == "ok") {
            $("#id_destaque").val("");
            showAlert("Sucesso", "Ação realizada com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // UPDATE FOTO DESCRICAO
  enviando_formulario = false;
  $("#form-update-foto-descricao").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm3");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          data = JSON.parse(data);
          if (data.status == "ok") {
            $("#id_destaque").val("");
            showAlert("Sucesso", "Ação realizada com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

})();
